export default function accessibility () {
  $('.dropdown-menu.inner').removeAttr('role');
}
